import { adminFetch } from "./_client";
import type { BookingsAtRisk, BookingsAtRiskFilters, AtRiskStateMutation, AtRiskStateResponse, AtRiskActionRequest, AtRiskActionResponse, AtRiskUndoRequest, AtRiskUndoResponse } from "./types";

export function fetchBookingsAtRisk(token: string, filters: BookingsAtRiskFilters = {}) {
  const qs = new URLSearchParams();
  if (filters.region) qs.set("region", filters.region);
  if (filters.bookingType) qs.set("booking_type", filters.bookingType);
  if (filters.rentalType) qs.set("rental_type", filters.rentalType);
  if (filters.includeSnoozed) qs.set("include_snoozed", "true");
  if (filters.assignee) qs.set("assignee", filters.assignee);
  if (filters.reason) qs.set("reason", filters.reason);
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return adminFetch<BookingsAtRisk>(`/admin/bookings-at-risk${suffix}`, token);
}


export function updateAtRiskState(token: string, body: AtRiskStateMutation) {
  return adminFetch<AtRiskStateResponse>("/admin/bookings-at-risk/state", token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}


export function executeAtRiskAction(token: string, body: AtRiskActionRequest) {
  return adminFetch<AtRiskActionResponse>("/admin/bookings-at-risk/action", token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function undoAtRiskAction(token: string, body: AtRiskUndoRequest) {
  return adminFetch<AtRiskUndoResponse>("/admin/bookings-at-risk/action/undo", token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
